import React from 'react';

const T = {
  mono: '"JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
  sans: '"Nunito", ui-sans-serif, system-ui, -apple-system, sans-serif',
  ink2: '#4A3510',
};

const BLOCK = {
  spec: {
    background: 'rgba(140,158,86,0.22)',
    border: '1px solid rgba(107,122,62,0.32)',
    labelColor: '#506024',
  },
  code: {
    background: 'rgba(213,128,108,0.22)',
    border: '1px solid rgba(193,74,51,0.32)',
    labelColor: '#9A3A26',
  },
};

export default function SpecCodeCompare({ specSays, codeSays }) {
  const block = (label, body, theme) => (
    <div style={{
      flex: 1,
      padding: 12,
      borderRadius: 8,
      background: theme.background,
      border: theme.border,
    }}>
      <div style={{
        fontFamily: T.mono, fontSize: 10, fontWeight: 800,
        letterSpacing: '0.6px', textTransform: 'uppercase',
        color: theme.labelColor, marginBottom: 6,
      }}>
        {label}
      </div>
      <div style={{ fontFamily: T.sans, fontSize: 13.5, color: T.ink2, lineHeight: 1.5 }}>
        {body}
      </div>
    </div>
  );
  return (
    <div style={{ display: 'flex', gap: 12 }}>
      {block('SPEC SAYS', specSays, BLOCK.spec)}
      {block('CODE SAYS', codeSays, BLOCK.code)}
    </div>
  );
}
